module.exports = __webpack_public_path__ + "static/media/asa.61a482f8.mp3";